import React, { useState, useEffect, useRef } from 'react'
import './select.scss'
import Image from '../Image'
import listenForOutsideClicks from '../../../utils/ListenForOutsideClick'

const AutoComplete = ({ placeholder, search, options, label, defaultValue, onChange, onSelect, nameKey, disabled }) => {
    const [open, setOpen] = useState(false)
    const [listening, setListening] = useState(false)
    const dropdownRef = useRef(), dropdownContainer = useRef(), inputRef = useRef()
    const [reformOption, setReformOption] = useState(options)
    useEffect(listenForOutsideClicks(listening, setListening, dropdownRef, setOpen))
    const dropdown = () => {
        if (options) {
            let bounding = dropdownRef.current.getBoundingClientRect();
            let position = bounding.bottom > 500 && options.length ? "up" : "down"
            setOpen(open ? !open : position)
        } else {
            setOpen(false)
        }
    }
    useEffect(() => {
        inputRef.current.value = defaultValue?.[nameKey ? nameKey : 'name'] || ""
    }, [defaultValue])
    useEffect(() => {
        setReformOption(options)
        setOpen(options ? true : false)
    }, [options])

    return (
        <div className='select-container' ref={dropdownRef}>
            {label && <label>{label}</label>}
            <div className='input' onClick={dropdown}>
                <input
                    placeholder={placeholder}
                    // readOnly={!search} 
                    disabled={disabled}
                    ref={inputRef}
                    // value={defaultValue?.[nameKey?nameKey:'name'] || ""}
                    onChange={(e) => {
                        let val = e.target.value
                        onChange(val)
                    }}
                />
                {
                    inputRef.current?.value ? (
                        <div onClick={(e) => {
                                e.stopPropagation()
                                inputRef.current.value =''
                                onSelect("")
                            }}>
                        <Image
                            
                            src={`/images/icons/close.svg`} svg/>
                        </div>
                       
                    ) : (<Image src={`/images/icons/search.svg`} />)
                }

            </div>
            {
                open && options && (
                    <ul className={`select-dropdown select-dropdown-${open}`} ref={dropdownContainer}>

                        {
                            reformOption.length ? reformOption.map(o => (
                                <li
                                    onClick={() => {
                                        onSelect(o)
                                        inputRef.current.value = o.name
                                        setOpen(false)
                                    }}
                                    className={`li ${defaultValue && (defaultValue[nameKey ? nameKey : 'name'] === o[nameKey ? nameKey : 'name']) ? 'li-selected' : ''}`}>{o[nameKey ? nameKey : 'name']}</li>)) : (<li>-- 無資料 --</li>)
                        }
                    </ul>
                )
            }


        </div>
    )
}

export default AutoComplete